import React, { useEffect } from "react";
import CategoryBudget from "./CategoryBudget";
import { useDispatch, useSelector } from "react-redux";
import { fetchTotalBudget } from "../../slices/totalBudgetSlice";
import { fetchYearId } from "../../slices/yearSlice";
import { formatZAR } from "../../constant/utils/commonUtils";
import { getLocalData } from "../../constant/utils/commonUtils";

const TrainingCategoryBudgetConfiguration = () => {
  const dispatch = useDispatch();
  const { totalBudget } = useSelector((state) => state.totalBudget);
  const companyId = getLocalData("sdfUser")?.company_id;

  useEffect(() => {
    const fetchData = async () => {
      if (!companyId) return;
      const yearRes = await dispatch(fetchYearId());
      const currentYearId = yearRes.payload;
      if (currentYearId) {
        dispatch(fetchTotalBudget({ yearId: currentYearId, companyId }));
      }
    };
    fetchData();
  }, [companyId, dispatch]);

  return (
    <div className="min-h-[calc(100vh-116px)]">
      <div className="flex justify-between gap-2 items-center mb-3">
        <h2 className="2xl:text-3xl 2xl:leading-3xl text-2xl leading-2xl text-blue-500 font-semibold">
          Training Category Budget
        </h2>
        <div className="flex items-center gap-2">
          <div className="relative total-budget-config-input">
            <div className="mx-2 flex items-center gap-1">
              <span className="text-sm font-medium text-gray-700">
                Total Budget:
              </span>
              <span className="text-base font-semibold text-blue-500">
                {formatZAR(totalBudget || 0)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <CategoryBudget />
    </div>
  );
};

export default TrainingCategoryBudgetConfiguration;
